module.exports = __webpack_public_path__ + "static/media/previewImageCard.c641d1a0.png";